import { request } from "@/utils/request";
import useSWR from "swr";

interface ResponseSwap {
  data: {
    total_fees_usd: string;
    total_value_locked_usd: string;
    total_volume_usd: string;
    tx_count: string;
  };
}

async function fetchSwap(url: string) {
  const response = await request(url);
  const data = await response.json();
  return data as ResponseSwap;
}

export function useHoldSwap() {
  const data = useSWR("/stats/swap", fetchSwap, {
    refreshInterval: 15_000,
    errorRetryInterval: 10_000,
  });

  return data;
}
